import React, { useEffect, useState } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { apiVerifyEmail } from '../../utils/api';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [verified, setVerified] = useState(false);
  useEffect(() => {
    const sendVerifyRequest = async () => {
      await apiVerifyEmail(searchParams.get('t'));
      setVerified(true);
    };

    sendVerifyRequest();
  });
  if (verified) {
    return <Navigate to="/home" replace />;
  }
  return <div />;
};

export default VerifyEmail;
